// @ts-nocheck
import {generateLotteryConfig} from "./lotteryDataTransformers";

/**
 * Lottery game configuration
 *
 * boardType options:
 * - 'thirty-eight': Uses RouletteBoardThirtyEight component (38 animals + special betting options)
 * - 'default': Uses traditional card-based betting interface
 *
 * This configuration is now dynamically generated from API data.
 * Use getLotteryConfig() to get the current configuration.
 */

// Fallback static configuration for when API is not available
const fallbackLotteryConfig = {
  "ruleta-activa": {
    id: 1,
    boardType: "thirty-eight",
  },
  "lotto-llano": {
    id: 2,
    boardType: "default",
  },
  "pal-caserito": {
    id: 3,
    boardType: "thirty-eight",
  },
  "la-ruca": {
    id: 4,
    boardType: "default",
  },
  "el-ruco": {
    id: 5,
    boardType: "default",
  },
};

/**
 * Get lottery configuration, either from API data or fallback
 * @param {Array} apiGames - Optional array of games from API
 * @returns {Object} - Lottery configuration
 */
export const getLotteryConfig = (apiGames = null) => {
  if (apiGames && apiGames.length > 0) {
    return generateLotteryConfig(apiGames);
  }
  return fallbackLotteryConfig;
};

// Export fallback for backwards compatibility
export const lotteryConfig = fallbackLotteryConfig;
